module.exports = __webpack_public_path__ + "img/ltkcurves-1x.a56161e.jpg";